import React from 'react';
import SectionTitle from '../../components/SectionTitle';

const HowItWorksSection = () => {

    const steps = [
        {
            stepNum: 1,
            stepTitle: 'Online Registration',
            stepDescription: 'Create your account and set up your profile on the MindMetric platform.'
        },
        {
            stepNum: 2,
            stepTitle: 'Answer Assessment Questions',
            stepDescription: 'Complete timed, rigorous aptitude and reasoning questions designed by experts.'
        },
        {
            stepNum: 3,
            stepTitle: 'Get Intelligence Report',
            stepDescription: 'Receive a detailed performance report, percentile rankings, and personalized insights.'
        }
    ];

    return (
        <div className="how-it-works-section pt---100 pb---100">
            <div className="container">
                <SectionTitle Title="How It Works" />

                <div className="row pt---30">
                    {steps.map((step, index) => (
                        <div key={index} className="col-md-4 wow animate__fadeInUp" data-wow-duration={`${0.3 + (index * 0.2)}s`}>
                            <div className="step-card" style={{
                                padding: '30px',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                textAlign: 'center',
                                transition: 'all 0.3s ease',
                                backgroundColor: '#f9f9f9'
                            }}>
                                <div className="step-number" style={{
                                    fontSize: '48px',
                                    fontWeight: 'bold',
                                    color: '#007bff',
                                    marginBottom: '20px'
                                }}>
                                    Step {step.stepNum}
                                </div>
                                <h3 style={{
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    marginBottom: '15px',
                                    color: '#333'
                                }}>
                                    {step.stepTitle}
                                </h3>
                                <p style={{
                                    color: '#666',
                                    lineHeight: '1.6',
                                    marginBottom: '20px'
                                }}>
                                    {step.stepDescription}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default HowItWorksSection;
